import { BIOCATCH_BRAND, ENV } from 'gatsby-env-variables';

import helpers from 'utils/helpers';
import { local } from 'utils/storage';

const contextMapper = (stepName) => {
  const mapper = {
    home: 'ONE_ITAU_PRODUCT_PAGE',
    cpf: 'ONE_ITAU_STEP_DOCUMENT',
    nome: 'ONE_ITAU_STEP_NAME',
    email: 'ONE_ITAU_STEP_EMAIL',
    celular: 'ONE_ITAU_STEP_PHONE',
    otp: 'ONE_ITAU_STEP_OTP',
    redirect: 'SESSION_ENDED',
  };

  return mapper?.[stepName];
};

const getBiocatchID = () => {
  const csid = local.getItem('csid') || helpers.session.guid();
  local.setItem('csid', csid);
  return csid;
};

const changeContext = (contextName) => {
  if (!window?.cdApi) {
    startBiocatch();
  }

  window?.cdApi?.changeContext(contextName);
};

const startBiocatch = () => {
  const scriptENV = ENV === 'production' ? 'p' : 's';

  helpers
    .addScript(`/js/bc-${scriptENV}-polyfill.js`, {
      'data-ot-ignore': true,
    })
    .then(() => {
      window?.cdApi?.setCustomerSessionId(getBiocatchID());
      window?.cdApi?.setCustomerBrand(BIOCATCH_BRAND);
    });
};

export default { startBiocatch, getBiocatchID, changeContext, contextMapper };
